import { render, staticRenderFns } from "./FormaPagoFormComponent.vue?vue&type=template&id=64cfae1e&"
import script from "./FormaPagoFormComponent.vue?vue&type=script&lang=js&"
export * from "./FormaPagoFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports